var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Carousel extends Component {
    constructor() {
        super('Carousel', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.carousel').each((carousel) => {
                const bs_carousel = new BS_Carousel(carousel.get(0));
                if (carousel.get(0).getAttribute('id') == 'carousel-last-publications-xs')
                    Carousel.lastPublicationsCarouselXS = bs_carousel;
                carousel.on('slide.bs.carousel', (e) => {
                    const indicator = carousel.find('.carousel-indicators-xs button');
                    indicator.removeClass('active').eq(e.to).addClass('active');
                });
            }).on('slid.bs.carousel', (event) => {
                const iframe = $(event.target).find('.carousel-item.active iframe');
                if (iframe.length > 0 && iframe.attr('data-refreshed') == undefined) {
                    if (iframe.attr('src') == '')
                        return;
                    iframe.attr('src', iframe.attr('data-src')).data('refreshed', true);
                }
            });
            this.success();
        });
    }
}
